export default "__VITE_ASSET__0lnJpAO3__"